import { render } from "./urgent_packets.vue?vue&type=template&id=822f4c86"
import script from "./urgent_packets.vue?vue&type=script&lang=js"
export * from "./urgent_packets.vue?vue&type=script&lang=js"

import exportComponent from "D:\\shiv_mfg_front\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__